module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper', _vm.classes]
  }, [_c('dash-header', {
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), _c('sidebar', {
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [(_vm.idioma === 'DE') ? _c('h1', [_vm._v("\n        " + _vm._s(_vm.$route.meta.nameDe.toUpper) + "\n        "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.descriptionDe))])]) : (_vm.idioma === 'EN') ? _c('h1', [_vm._v("\n        " + _vm._s(_vm.$route.meta.nameEn) + "\n        "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.descriptionEn))])]) : (_vm.idioma === 'ES') ? _c('h1', [_vm._v("\n        " + _vm._s(_vm.$route.meta.nameEs) + "\n        "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.descriptionEs))])]) : _c('h1', [_vm._v("\n        " + _vm._s(_vm.$route.meta.namePtBr) + "\n        "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.descriptionPtBr))])]), _vm._v(" "), (_vm.idioma === 'DE') ? _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.nameDe))])]) : (_vm.idioma === 'EN') ? _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.nameEn))])]) : (_vm.idioma === 'ES') ? _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(2), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.nameEs))])]) : _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(3), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.namePtBr))])])]), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('dash-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v("Hauptsächlich")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v("Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v("Principal")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v("Principal")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a70dd582"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dash.vue
// module id = 685
// module chunks = 1